module.exports = __webpack_public_path__ + "static/media/7.fda112c7.jpg";